
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import regular from "@/common/regular";
import validate from "@/common/regular";
import { addDeviceArchive, getDeviceArchive } from "@/api/api-basic";
import i18n from "@/config/i18n";
import uploadImage from "@/components/upload-image/upload-image.vue";
import showImg from "@/components/show-img/show-img.vue";
import { getOptionList, optionKey } from "@/api/api-dict";
@Component({
  components: {
    "pi-upload-image": uploadImage,
    "pi-show-img": showImg
  }
})
export default class PiAddReportFile extends Vue {
  private modalShow = false;
  private modalTitle = "";
  private loading = false;
  private formInlineJson: objAny = {};
  private formInline: objAny = {
    deviceModelPkIdList: [
      { deviceModelName: "", deviceModelRatedPower: "", deviceModelPkId: "" },
      { deviceModelName: "", deviceModelRatedPower: "", deviceModelPkId: "" },
      { deviceModelName: "", deviceModelRatedPower: "", deviceModelPkId: "" }
    ],
    deviceType: "",
    manufacturerName: "",
    archiveCode: "",
    archiveCreateDate: "",
    attachmentRecordPkId: "",
    deviceStandardPkId: "",
    feelerMechanismName: "",

    attachmentRecordName: "",
    attachmentRecordFilePath: ""
  };
  private devTypeList: objAny[] = [];
  private deviceModelList: objAny[] = [];
  private deviceStandardList: objAny[] = [];

  private itemData: objAny = {};
  private formObj: objAny = {};
  private ruleInline: objAny = {
    deviceType: [
      {
        required: true,
        message:
          i18n.t("regular.please") +
          "" +
          i18n.t("reportFile.attachmentRecordPkId"), //"请选择设备类型",
        trigger: "change"
      }
    ],
    manufacturerName: [
      {
        required: true,
        message:
          i18n.t("regular.please") + "" + i18n.t("reportFile.manufacturerName"), //"请输入生产产商",
        trigger: "blur"
      }
    ],
    deviceModelPkId: [
      {
        required: true,
        message:
          i18n.t("regular.please") + "" + i18n.t("reportFile.deviceModelName"), //"请选择设备型号",
        trigger: "change"
      }
    ],
    deviceRatedPower: [
      {
        required: true,
        validator: validate.money,
        trigger: "blur",
        name: i18n.t("reportFile.deviceModelRatedPower") //"额定功率"
      }
    ],
    deviceStandardPkId: [
      {
        required: true,
        message:
          i18n.t("regular.pleaseSelect") +
          "" +
          i18n.t("reportFile.deviceModelChargeStandardName"), //"请选择设备标准",
        trigger: "change"
      }
    ],
    archiveCode: [
      {
        required: true,
        message:
          i18n.t("regular.please") + "" + i18n.t("reportFile.archiveCode"), //"请输入报告编号",
        trigger: "blur"
      }
    ],
    archiveCreateDate: [
      {
        required: true,
        type: "date",
        message:
          i18n.t("regular.pleaseSelect") +
          "" +
          i18n.t("reportFile.archiveCreateDate"), //"请选择报告生成日期",
        trigger: "change"
      }
    ],
    attachmentRecordPkId: [
      {
        required: true,
        message:
          i18n.t("regular.pleaseSelect") +
          "" +
          i18n.t("reportFile.attachmentRecordPkId"), //"请上传型式实验报告",
        trigger: "change"
      }
    ],
    feelerMechanismName: [
      {
        required: true,
        message:
          i18n.t("regular.please") +
          "" +
          i18n.t("reportFile.feelerMechanismName"), //"请输入检测机构名称",
        trigger: "blur"
      }
    ]
  };
  public uploadImg(data: objAny): void {
    this.formInline.attachmentRecordFilePath = data.filePath;
    this.formInline.attachmentRecordName = data.fileName;
    this.formInline.attachmentRecordPkId = data.attachmentRecordPkId; //data.thumbnailFilePath;
  }

  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.loading = true;
        this.addData();
      }
    });
  }

  public getSubData(): objAny {
    const deviceModelPkIdList: string[] = [];
    this.formInline.deviceModelPkIdList.map((item: objAny) => {
      if (item.deviceModelPkId) {
        deviceModelPkIdList.push(item.deviceModelPkId);
      }
    });
    const data: objAny = {
      deviceModelPkIdList: deviceModelPkIdList,
      archiveCode: this.formInline.archiveCode,
      archiveCreateDate: this.$common.thisTimes(
        "yyyy-MM-dd",
        new Date(this.formInline.archiveCreateDate)
      ),
      attachmentRecordPkId: this.formInline.attachmentRecordPkId,
      feelerMechanismName: this.formInline.feelerMechanismName
    };
    return data;
  }
  async addData(): Promise<void> {
    this.loading = true;
    const ret = await addDeviceArchive(this.getSubData());
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("addSuccess") + "");
      this.$emit("success");
      this.closeModal();
    }
    this.loading = false;
  }

  async getOptionList() {
    const ret = await getOptionList([optionKey.devTypeList]); //请求字典
    this.devTypeList = ret[optionKey.devTypeList]; //
    if (this.devTypeList[0]) {
      this.formInline.deviceType = this.devTypeList[0].itemKey;
      this.getModelList();
    }

    // this.devTypeList = ret[optionKey.devTypeList]; //
  }
  public devTypeChange(): void {
    if (this.formInline.deviceType) {
      this.getModelList();
    }
  }
  // 获取设备型号
  async getModelList(): Promise<void> {
    const ret = await getDeviceArchive({
      deviceType: this.formInline.deviceType
    });
    if (ret.status === this.$config.apiStatus) {
      this.deviceModelList = ret.data;
    }
  }
  public deviceModelChange(index: number): void {
    const item: objAny =
      JSON.parse(JSON.stringify(this.deviceModelList[index])) || {};
    delete item.deviceModelPkId;
    const itemData = Object.assign(
      this.formInline.deviceModelPkIdList[index],
      item
    );
    this.$set(this.formInline.deviceModelPkIdList, index, itemData);
  }
  open() {
    this.modalShow = true;
    if (this.formInlineJson.deviceType == null) {
      this.formInlineJson = JSON.parse(JSON.stringify(this.formInline));
    }
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
      this.handleReset();
      this.getOptionList();

      this.modalTitle = i18n.t("add") + "";
    });
  }
  handleReset() {
    this.formInline = JSON.parse(JSON.stringify(this.formInlineJson));
    this.formObj.resetFields();
  }
  closeModal() {
    this.modalShow = false;
  }
}
